import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { UserRole } from '../models/general.models';
import RouteAuthorizer from './components/RouteAuthorizer';
import { AppRoutes } from './routes';
var RedeemCouponPage = React.lazy(function () { return import('../pages/redeemCoupon/redeemCoupon'); });
var RedeemedCouponPage = React.lazy(function () { return import('../pages/redeemCoupon/redeemedCoupon'); });
var RedeemCouponForbiddenPage = React.lazy(function () { return import('../pages/redeemCoupon/redeemCouponForbidden'); });
var RedeemCouponRedirectPages = [
    {
        userRole: UserRole.Anonymous,
        page: AppRoutes.IntroRedeemCoupon,
    },
    {
        userRole: UserRole.NoCountryUser,
        page: AppRoutes.IntroRedeemCoupon,
    },
    {
        userRole: UserRole.PartialUser,
        page: AppRoutes.JoinFamily,
    },
    {
        userRole: UserRole.PlanPendingUser,
        page: AppRoutes.OnboardingWelcomePage,
    },
];
var redeemCouponRoutes = [
    {
        path: AppRoutes.RedeemCoupon,
        element: (_jsx(RouteAuthorizer, { userRoles: [UserRole.CompleteUser, UserRole.UserPaymentNeeded], redirectPages: RedeemCouponRedirectPages, children: _jsx(RedeemCouponPage, {}) })),
    },
    {
        path: AppRoutes.CouponRedeemed,
        element: (_jsx(RouteAuthorizer, { userRoles: [
                UserRole.CompleteUser,
                UserRole.UserPaymentNeeded,
                UserRole.PlanPendingUser,
            ], redirectPages: RedeemCouponRedirectPages, children: _jsx(RedeemedCouponPage, {}) })),
    },
    {
        path: AppRoutes.RedeemCouponForbidden,
        element: (_jsx(RouteAuthorizer, { userRoles: [UserRole.CompleteUser, UserRole.UserPaymentNeeded], redirectPages: RedeemCouponRedirectPages, children: _jsx(RedeemCouponForbiddenPage, {}) })),
    },
];
export default redeemCouponRoutes;
